import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import { toggleSearchBar } from "../../actions/settingsAction";
import { useSelector, useDispatch } from "react-redux";
import { fetchClients, getClientByLocalStorage } from "../../actions/summary";
import { GETING_DATA_BY_LOCALSTORAGE } from "../../actions/index";
import Pagination from "../Pagination/Pagination";
import close from "../../assets/images/cross_cancel.png";

const Searchbar = ({ isSearchbar, toggleSearchBar }) => {
  const history = useHistory();
  const value = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const auth = useSelector((state) => state?.auth?.user);
  let clients = useSelector((state) => state?.summary?.totalClient?.data);
  const dispatch = useDispatch();

  const [searchBy, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [orgType, setOrgType] = useState("parentOrg");
  const [totalItems, settotalItems] = useState(1);  
  // Remove duplicates based on _id
  const uniqueClients = clients?.filter((client, index, self) => 
    index === self.findIndex(c => c._id === client._id)
  ) || [];
  
  const totalClient = useSelector(
    (state) => state?.summary?.totalClient?.currentCount
  );
  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    setTimeout(() => {
      setSearch(inputValue);
      setPage(1);
    }, 500);
  };

  useEffect(() => {
    if (auth.accessLevel === "Client" || auth.accessLevel === "Manager") {
      fetchClients(dispatch, auth.accessLevel, page, searchBy, orgType);
      localStorage.setItem("org", JSON.stringify(auth.organisationId || {}));
      dispatch({
        type: GETING_DATA_BY_LOCALSTORAGE,
        localClient: auth.organisationId || {},
      });
    } else {
      fetchClients(dispatch, auth.accessLevel, page, searchBy, orgType);
      if (auth.accessLevel !== "Client") {
        getClientByLocalStorage(dispatch, auth.accessLevel);
      }
    }
  }, [dispatch, auth.accessLevel, page, searchBy, orgType]);

  useEffect(() => {
    settotalItems(totalClient);
  }, [totalClient]);

  // Reset page when search changes
  useEffect(() => {
    if (searchBy !== "") {
      setPage(1);
    }
  }, [searchBy]);

  // Reset page when org type changes
  useEffect(() => {
    setPage(1);
  }, [orgType]);


  return (
    <>
      <div className={`overlay${isSearchbar ? " overlay_open" : ""}`}></div>
      <div
        className={`search_div${isSearchbar ? " open" : ""}`}
        style={{ overflow: "scroll" }}
      >
        <div className="card mb-0">
          <div className="body p-0">
            <form id="navbar-search" className="navbar-form search-form">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Search</h5>
                <span className="search_toggle btn btn-danger" onClick={() => toggleSearchBar(false)}>
                  <img src={close} alt="close" className="img-fluid" style={{ maxWidth: '13px' }} />
                </span>
              </div>
              <div className="search-input searchInputNew">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={handleSearchChange}
                />
              </div>
              <div className="mt-3">
                <label className="font-weight-bold" style={{ color: "#211F54" }}>Org Type</label>
                <select
                  className="form-control"
                  value={orgType}
                  onChange={(e) => setOrgType(e.target.value)}
                >
                  <option value="parentOrg">Parent Org</option>
                  <option value="forestView">Forest View</option>
                </select>
              </div>
            </form>
          </div>
        </div>
        <span className="mt-3 mb-3 d-block" style={{ color: "#211F54", fontWeight: "500" }}>
          Search Result (Page {page}, Items {((page - 1) * 10) + 1}-{((page - 1) * 10) + (uniqueClients?.length || 0)})
        </span>
        <table className="table table-hover table-custom spacing5">
          <tbody>
            {uniqueClients?.map((row, index) => {
              return (
                <tr key={row?._id || row?.orgName || index}>
                  <td className="w40">
                    <span>{(page - 1) * 10 + 1 + index}</span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div
                        className="avtar-pic w35 bg-red"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title="Avatar Name"
                      >
                        <span>{row?.orgName?.match(/\b\w/g)?.join("")}</span>
                      </div>
                      <div className="ml-3">
                        <Link
                          to="/"
                          onClick={() => {
                            localStorage.setItem("org", JSON.stringify(row));
                            localStorage.setItem(
                              "OrgName",
                              JSON.stringify(row?.orgName)
                            );
                            sessionStorage.clear()
                            window.history.replaceState({}, "", "/");

                            dispatch({
                              type: GETING_DATA_BY_LOCALSTORAGE,
                              localClient: row,
                            });
                            window.location.reload();
                          }}
                          title=""
                        >
                          {row?.orgName}
                        </Link>
                        <p className="mb-0">{row?.orgEmail}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="dataTables_paginate">
          {totalItems > 0 &&
            <Pagination
              className="pagination-bar"
              currentPage={page}
              totalCount={totalItems}
              pageSize={10}
              onPageChange={(page) => {
                setPage(page);
              }}
            />}
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  isSearchbar: state.settings.isSearchbar,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSearchBar: (e) => dispatch(toggleSearchBar(e)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Searchbar);
